import {
  buildImageGenMetaFromApiSnapshot,
} from '@glyphic/shared-core'

import type { ComicProjectSettings } from './comicDomainTypes'
import type { ComicPageGenerationSnapshot } from './comicTypes'

export type { ComicPageGenerationSnapshot } from './comicTypes'

export function buildPageGenerationSnapshot(
  settings: ComicProjectSettings,
  panelAspect: string,
  options?: {
    mode?: ComicPageGenerationSnapshot['mode']
    superResolution?: boolean
  },
): ComicPageGenerationSnapshot {
  return {
    platformId: settings.platformId,
    modelId: settings.modelId,
    apiSize: settings.apiSize,
    aspectRatio: panelAspect.trim() || null,
    mode: options?.mode ?? 'TEXT_TO_IMAGE',
    superResolution: options?.superResolution ?? false,
    candidatesPerGeneration: settings.candidatesPerGeneration,
  }
}

export function normalizePageGenerationSnapshot(raw: unknown): ComicPageGenerationSnapshot | undefined {
  if (!raw || typeof raw !== 'object') return undefined
  const o = raw as Record<string, unknown>
  const platformId = typeof o.platformId === 'string' ? o.platformId.trim() : ''
  const modelId = typeof o.modelId === 'string' ? o.modelId.trim() : ''
  if (!platformId && !modelId) return undefined
  const mode = o.mode === 'IMAGE_TO_IMAGE' ? 'IMAGE_TO_IMAGE' : 'TEXT_TO_IMAGE'
  return {
    platformId,
    modelId,
    apiSize: typeof o.apiSize === 'string' ? o.apiSize : '',
    aspectRatio:
      typeof o.aspectRatio === 'string' && o.aspectRatio.trim() ? o.aspectRatio.trim() : null,
    mode,
    superResolution: o.superResolution === true,
    candidatesPerGeneration:
      typeof o.candidatesPerGeneration === 'number' && o.candidatesPerGeneration >= 1
        ? Math.min(4, Math.round(o.candidatesPerGeneration))
        : 1,
  }
}

export function pageGenerationSnapshotMetaParts(
  snapshot: ComicPageGenerationSnapshot | undefined,
  clientModelLabel?: string,
  sizeLabel?: string,
): string[] {
  if (!snapshot) return []
  return buildImageGenMetaFromApiSnapshot({
    platform: snapshot.platformId,
    modelLabel: clientModelLabel,
    modelId: snapshot.modelId,
    apiSize: snapshot.apiSize,
    sizeLabel,
    aspectRatio: snapshot.aspectRatio,
    count: snapshot.candidatesPerGeneration,
    extras: snapshot.superResolution ? ['超分'] : undefined,
  })
}

export function formatPageGenerationSnapshotLabel(
  snapshot: ComicPageGenerationSnapshot | undefined,
  clientModelLabel?: string,
  sizeLabel?: string,
): string {
  const parts = pageGenerationSnapshotMetaParts(snapshot, clientModelLabel, sizeLabel)
  return parts.length ? parts.join(' · ') : ''
}
